<template>
	<div id="nav">
		<a href="/" class="img">
			<img width="100%" src="img/logo_perso.png" alt="">

		</a>

		<h1>amdeveloper</h1>

		<div class="toggle-menu" id="burger" :class="{'active':isBurgerActive}" @click="toggle()">
		<slot>
			<button type="button" class="burger-button" title="menu">
				<span class="burger-bar burger-bar--1"></span>
				<span class="burger-bar burger-bar--2"></span>
				<span class="burger-bar burger-bar--3"></span>
			</button>
		</slot>


		</div>
		<div id="menu" :class="{'active':isBurgerActive}" @click="toggle()">
			<router-link to="/">Home</router-link>
			<router-link to="/apropos">A propos</router-link>
			<router-link to="/realisations">Réalisation</router-link>
			<router-link to="/competences">Compétences</router-link>
			<router-link to="/contact">Contact</router-link>
			<router-link to="/experiences">Experiences</router-link>
		</div>

	</div>
</template>

<script>
	// @ is an alias to /src

	export default {
		name: 'navbar',
		components: {},
		data:()=>({
		isBurgerActive:false
		}),
		methods: {
          toggle(){
			  this.isBurgerActive = !this.isBurgerActive
          }
		},

	}
</script>
<style>
	#nav {
		display: flex;
		justify-content: space-between;
		align-items: center;
		padding: 10px 40px;
		position: relative;
		height: 70px;
		box-shadow: 1px 0px 8px 0px #000000;
	}

	#nav .img {
		height: 100%;
		width:70px;
	}

	#nav a {
		font-weight: bold;
	}


	#nav #menu a {
		padding: 15px;
	}


	ul, li, li a {
		list-style: none;
		display: block;
		margin: 0;
		padding: 0;
	}

	li a {
		padding: 5px;
		color: #888;
		text-decoration: none;
		transition: all .2s;
	}

	li a:hover,
	li a:focus {
		background: #1ABC9C;
		color: #fff;
	}

	.hidden {
		visibility: hidden;
	}

	button {
		cursor: pointer;
	}

	/* remove blue outline */
	button:focus {
		outline: 0;
	}

	.burger-button {
		position: relative;
		height: 45px;
		width: 45px;
		display: block;
		z-index: 999;
		border: 0;
		border-radius: 0;
		background-color: transparent;
		pointer-events: all;
		transition: transform .6s cubic-bezier(.165,.84,.44,1);
	}

	.burger-bar {
		background-color: #fff6fc;
		position: absolute;
		top: 20px;
		right: 6px;
		left: 6px;
		height: 4px;
		border-radius: 20px;
		width: auto;
		transition: transform .6s cubic-bezier(.165,.84,.44,1),opacity .3s cubic-bezier(.165,.84,.44,1),background-color .6s cubic-bezier(.165,.84,.44,1);
	}

	.burger-bar--1 {
		-webkit-transform: translateY(-6px);
		transform: translateY(-6px);
	}

	.burger-bar--2 {
		transform-origin: 100% 50%;
		transform: scaleX(.8);
		margin-top:3px;
	}

	.burger-button:hover .burger-bar--2 {
		transform: scaleX(1);
		margin-top:3px;

	}
	.burger-button .burger-bar--3 {
		margin-top: 6px;
	}

	.no-touchevents .burger-bar--2:hover {
		transform: scaleX(1);
	}
	#menu{
		display: none;
		top:0;
		transition: .3s;
    z-index: 1;
	}
	#menu.active{
		background:#063D60;
		display: flex;
		flex-direction: column;
		position: absolute;
		right:0px;
		top:100%;
	}
	.burger-bar--3 {
		transform: translateY(6px);
	}

	#burger.active .burger-button {
		transform: rotate(-180deg);
	}

	#burger.active .burger-bar {
		background-color: #fff;
	}

	#burger.active .burger-bar--1 {
		transform: rotate(45deg)
	}

	#burger.active .burger-bar--2 {
		opacity: 0;
	}

	#burger.active .burger-bar--3 {
		margin-top:1px;

		transform: rotate(-45deg)
	}


</style>
